/**
 * Subset of the service provider payload the KYC banner depends on.
 *
 * Structural on purpose: `shared-frontend` cannot import
 * `GetServiceProviderResult` from `@pflegenavi/service-provider-frontend/api`,
 * because that package already depends on this one.
 */
export interface KycBannerServiceProvider {
  payment_service_provider?: 'mangopay' | 'stripe' | null;
  mangopay_user_id?: string | null;
  mangopay_kyc_verified?: boolean;
}

/**
 * KYC is outstanding as soon as the MangoPay user exists — it does not depend on
 * the bank account, which providers can skip on web (ENG-2374).
 *
 * Shared by the web and mobile dashboard banners.
 */
export const shouldShowKycBanner = (
  data: KycBannerServiceProvider | undefined
): boolean =>
  data?.payment_service_provider === 'mangopay' &&
  Boolean(data?.mangopay_user_id) &&
  !data?.mangopay_kyc_verified;
